/**
 * Single Result JS
 * -----------------------------------------------------------------------------
 *
 * All the JS for the Single Result component.
 */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( '.ll-single__results-main-slider' ).slick( {
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false,
        draggable: false,
        asNavFor: '.ll-single__results-slider',
        arrows: true,
        infinite: false,
      } );

      $( '.ll-single__results-slider' ).slick( {
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.ll-single__results-main-slider',
        arrows: true,
        draggable: false,
        focusOnSelect: true,
        prevArrow: $( '.single-result' ).find( '.prev-slide' )[0],
        nextArrow: $( '.single-result' ).find( '.next-slide' )[0],
        infinite: false,
        centerMode: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: true,
              draggable: true,
            },
          },
        ],
      } );
    },
    finalize: function() {},
  };

  // Hooks the component into the app
  app.registerComponent( 'single-result', COMPONENT );
} )( app );
